import km from 'keymirror';
import _ from 'underscore';

export default _.extend(
  {
    /* 1:表示企业专区类型，如果以后有其他类似活动，依次扩展 */
    BUSINESS_ENTERPRISE_TYPE: 1,
    BUSINESS_GIFT_TYPE: 2, // 礼物派
    BUSINESS_GIFTPACKAGE_TYPE: 4, //礼包档位区
    BUSINESS_PICKUPCARD_TYPE: 7, // 提货券专区
  },
  km({
    // 获取指定企业专区商品信息 success
    BUSINESS_ENTERPRISE_PRODUCT_INFO_SUCCESS: null,
    // 获取指定企业专区商品信息 fail
    BUSINESS_ENTERPRISE_PRODUCT_INFO_ERROR: null
  })
);
